// appLock.js — kyçja e aplikacionit me gjurmë, fytyrë ose PIN-in e telefonit.
//
// ÇFARË ËSHTË DHE ÇFARË NUK ËSHTË. Ky është një bravë në derë, jo një kasafortë.
// Plugin-i `@aparajita/capacitor-biometric-auth` VETËM verifikon identitetin te
// sistemi; nuk ruan dhe nuk kripton asgjë. Token-i i sesionit mbetet po aty ku
// ishte, te `@capacitor/preferences`. Domethënë kjo e ndal dikë që merr në dorë
// telefonin tënd të shkyçur — nuk e ndal dikë me akses rrënjë te pajisja. Për
// këtë aplikacion mjafton, por s'duhet shitur si më shumë se kaq.
//
// VENDIMI VJEN NGA SERVERI. `rpc_my_biometric_mode()` kthen tri gjendje:
//   'off'       — as nuk ekziston për këtë përdorues
//   'optional'  — i ofrohet; zgjedhja e tij ruhet PER PAJISJE
//   'required'  — kyçet gjithmonë, pa çelës për ta fikur
// Zinxhiri person → familje → platformë llogaritet te baza (BIOMETRIC_gate.sql),
// që klienti të mos e rindërtojë dot ndryshe.
//
// PER PAJISJE, jo per llogari: telefoni i punës dhe ai i shtëpisë s'kanë pse ta
// kenë të njëjtën sjellje, dhe zgjedhja s'ka kuptim të udhëtojë me llogarinë.

import { Capacitor } from "@capacitor/core";
// ⚠ 5 shtator 2026 — parazgjedhjet e dritares biometrike ishin shqip të
// ngulitura. Thirrësit e kalojnë tekstin e përkthyer për `reason`, `cancel`
// dhe `title`, po `fallback` («Përdor kodin») nuk e kalon askush — pra ai
// dilte gjithmonë shqip, te dritarja e vetë iOS-it. Ky skedar s'është
// komponent, ndaj merr instancën e i18n-it drejtpërdrejt.
import i18n from "./i18n";
import { Preferences } from "@capacitor/preferences";
import { BiometricAuth, AndroidBiometryStrength } from "@aparajita/capacitor-biometric-auth";
import { supabase } from "./supabaseClient";

// PER LLOGARI DHE PER PAJISJE. Fillimisht këta çelësa ishin vetëm per pajisje,
// dhe kjo ishte gabim: në një telefon familjar, personi i dytë që hyn nuk do të
// pyetej kurrë — do të trashëgonte në heshtje përgjigjen e të parit. Kërkesa
// ishte "kur personi ben login per her te par ne ate paisje", pra çelësi duhet
// të mbajë EDHE se cili person.
const PREF_ON_BASE = "pef.applock.on";       // "1" | "0" — zgjedhja e përdoruesit
const PREF_ASKED_BASE = "pef.applock.asked"; // "1" — e kemi pyetur njëherë
const PREF_AT_BASE = "pef.applock.at";       // kur u shkyç së fundmi

// Ndryshimet duhet të duken menjëherë te "Siguria e llogarisë" dhe te vetë brava,
// pa pritur rinisjen e aplikacionit. Një ngjarje e vetme i lidh të dyja.
export const CHANGED = "pef:applock-changed";
function announce() {
  try { window.dispatchEvent(new Event(CHANGED)); } catch (_e) { /* pa DOM */ }
}

let _uid = null;
async function uid() {
  if (_uid) return _uid;
  try {
    const { data } = await supabase.auth.getSession();
    _uid = data?.session?.user?.id || null;
  } catch (_e) { _uid = null; }
  return _uid;
}
/** Thirret kur ndryshon llogaria, që çelësat të mos mbeten te e vjetra. */
export function setAccount(id) { _uid = id || null; }

async function keyOn() { return `${PREF_ON_BASE}.${(await uid()) || "anon"}`; }
async function keyAsked() { return `${PREF_ASKED_BASE}.${(await uid()) || "anon"}`; }
async function keyAt() { return `${PREF_AT_BASE}.${(await uid()) || "anon"}`; }

// Sa gjatë mund të rrijë aplikacioni në sfond pa u rikyçur. Pa këtë, çdo kalim
// te galeria për të zgjedhur një foto do të kërkonte gjurmën në kthim — dhe
// veçoria do të hiqej brenda ditës.
export const GRACE_MS = 2 * 60 * 1000;

export const isNative = Capacitor.isNativePlatform();

// ---------------------------------------------------------------------------
// AFATI PËR THIRRJET NATIVE
//
// 28 gusht 2026. `BiometricAuth.checkBiometry()` nuk u kthye kurrë brenda
// WKWebView-it të iOS-it, dhe aplikacioni vdiste rreth dhjetë sekonda më vonë —
// pikërisht afati pas të cilit iOS-i vret një aplikacion që s'përgjigjet.
// Shkaku ishte një mospërputhje versionesh: plugin-i i serisë 9 është ndërtuar
// për Capacitor 7, ndërsa projekti ka kaluar te Capacitor 8. Ai u përditësua.
//
// Por rrënja e vërtetë e dëmit s'ishte versioni: ishte se ne e prisnim atë
// përgjigje PA AFAT. Një bravë që nuk përgjigjet duhet të mbetet e mbyllur, jo
// ta rrëzojë derën. Prandaj çdo thirrje drejt sistemit ka tash një kufi kohe:
// nëse s'kthehet, e trajtojmë si "kjo pajisje s'e mban" dhe aplikacioni vazhdon.
//
// KUFIRI, i thënë hapur: ky afat mbron nga një premtim që nuk zgjidhet kurrë.
// Nëse një ditë vetë ana native e bllokon fijen kryesore të sistemit, JavaScript-i
// s'ka si ta shpëtojë — atje ndihmon vetëm plugin-i i saktë.
const AFATI_MS = 4000;

function meAfat(premtimi, emri) {
  return new Promise((zgjidh) => {
    let mbaroi = false;
    const ora = setTimeout(() => {
      if (mbaroi) return;
      mbaroi = true;
      console.warn(`[bravë] ${emri} nuk u kthye brenda ${AFATI_MS}ms — vazhdojmë pa të.`);
      zgjidh(null);
    }, AFATI_MS);
    premtimi.then(
      (v) => { if (!mbaroi) { mbaroi = true; clearTimeout(ora); zgjidh(v); } },
      (e) => { if (!mbaroi) { mbaroi = true; clearTimeout(ora); zgjidh({ __gabim: e }); } },
    );
  });
}

async function prefGet(key) {
  try { const { value } = await Preferences.get({ key }); return value; }
  catch (_e) { return null; }
}
async function prefSet(key, value) {
  try { await Preferences.set({ key, value }); } catch (_e) { /* pa ruajtje — pyetet sërish */ }
}

/** Gjendja e caktuar nga admini për këtë përdorues. Fail-closed te 'off'. */
export async function fetchMode() {
  if (!isNative) return "off";
  const { data, error } = await supabase.rpc("rpc_my_biometric_mode");
  if (error) {
    console.warn("[bravë] rpc_my_biometric_mode dështoi:", error.message || error);
    return "off";
  }
  const m = Array.isArray(data) ? data[0] : data;
  return m === "required" || m === "optional" ? m : "off";
}

/** Çfarë mundëson vërtet kjo pajisje. */
export async function capability() {
  if (!isNative) return { usable: false, biometry: false, deviceIsSecure: false, reason: "web" };
  try {
    const r = await meAfat(BiometricAuth.checkBiometry(), "checkBiometry");
    // `null` = afati skadoi; `__gabim` = plugin-i u ankua. Të dyja do të thonë
    // të njëjtën gjë për përdoruesin: kjo pajisje s'e mban bravën tani.
    if (!r || r.__gabim) {
      return {
        usable: false, biometry: false, deviceIsSecure: false,
        reason: r ? String(r.__gabim?.message || r.__gabim) : "afati skadoi",
      };
    }
    return {
      // `deviceIsSecure` = ka PIN/model/fjalëkalim ekrani. Mjafton, sepse
      // kyçjen e lejojmë të kalojë edhe me kredencialin e pajisjes.
      usable: !!(r.isAvailable || r.deviceIsSecure),
      biometry: !!r.isAvailable,
      deviceIsSecure: !!r.deviceIsSecure,
      // Cilat lloje i ekspozon vërtet kjo pajisje, dhe a ka ndonjë "të fortë".
      // Njohja e fytyrës në shumicën e telefonave Android është e klasës së
      // dobët, dhe disa prodhues nuk ia ekspozojnë fare aplikacioneve — pra
      // pyetja "a e sheh sistemi fytyrën" duhet t'i bëhet vetë sistemit.
      types: Array.isArray(r.biometryTypes) ? r.biometryTypes : (r.biometryType ? [r.biometryType] : []),
      strong: !!r.strongBiometryIsAvailable,
      reason: r.reason || "",
    };
  } catch (e) {
    return { usable: false, biometry: false, deviceIsSecure: false, reason: String(e?.message || e) };
  }
}

export async function isEnabledOnDevice() { return (await prefGet(await keyOn())) === "1"; }
export async function setEnabledOnDevice(on) {
  await prefSet(await keyOn(), on ? "1" : "0");
  await prefSet(await keyAsked(), "1");
  announce();
}
export async function wasAsked() {
  const v = await prefGet(await keyAsked());
  if (v !== null) return v === "1";
  // Migrim i heshtur nga çelësi i vjetër pa llogari: kush ka përgjigjur tashmë
  // në këtë pajisje s'duhet pyetur sërish vetëm sepse ne e ndërruam emrin.
  const legacy = await prefGet(PREF_ASKED_BASE);
  if (legacy === "1") {
    const legacyOn = await prefGet(PREF_ON_BASE);
    await prefSet(await keyOn(), legacyOn === "1" ? "1" : "0");
    await prefSet(await keyAsked(), "1");
    return true;
  }
  return false;
}
export async function markAsked() { await prefSet(await keyAsked(), "1"); announce(); }

/**
 * Shkyçja e fundit, e shkruar te ruajtja native.
 *
 * PSE JO NË MEMORIE. Deri tani "e shkyçur" jetonte vetëm te një `ref`, dhe një
 * rifreskim faqeje e fshin atë bashkë me gjithë modulin — pra çdo rifreskim
 * kërkonte gjurmën sërish, edhe pse ishe po ai person, në po atë pajisje, dy
 * sekonda më vonë. Në telefon rifreskimi është gjest i zakonshëm (tërheq
 * poshtë), jo rinisje e aplikacionit, dhe kyçja s'ka pse ta trajtojë si të tillë.
 *
 * Afati është i njëjti si te kthimi nga sfondi. Një rregull, jo dy: nëse dy
 * minuta pushim s'e meritojnë një kyçje, as një rifreskim s'e meriton.
 */
export async function markUnlocked() {
  await prefSet(await keyAt(), String(Date.now()));
}
export async function clearUnlocked() {
  await prefSet(await keyAt(), "0");
}
/**
 * A është ky NJË RIFRESKIM brenda së njëjtës hapje të aplikacionit, apo një
 * hapje krejt e re?
 *
 * `sessionStorage` e ndan saktësisht: mbijeton një rifreskim faqeje, por
 * pastrohet kur sistemi e vret procesin — pra kur aplikacioni hapet vërtet nga
 * e para. Është e njëjta veti që e bënte të papërshtatshme për të mbajtur
 * sesionin e hyrjes, dhe pikërisht ajo që duhet këtu.
 */
function sameAppRun() {
  try {
    if (sessionStorage.getItem("pef.applock.run") === "1") return true;
    sessionStorage.setItem("pef.applock.run", "1");
    return false;
  } catch (_e) { return false; }
}

/**
 * Afati i mëshirës vlen VETËM brenda së njëjtës hapje.
 *
 * Më parë mjaftonte shenja e kohës, dhe kjo e bënte bravën të kapërcehej edhe
 * kur aplikacioni hapej nga e para brenda dy minutash — pra pikërisht kur
 * duhej të pyeste. Hapja e aplikacionit është momenti që kjo veçori ekziston
 * për ta mbrojtur; rifreskimi nuk është.
 */
export async function withinGrace() {
  if (!sameAppRun()) return false;
  const raw = await prefGet(await keyAt());
  const at = Number(raw || 0);
  if (!at) return false;
  return Date.now() - at < GRACE_MS;
}

/**
 * Vetëm kredenciali i pajisjes — PIN, model ose fjalëkalim. E veçantë nga
 * `authenticate()` sepse te ekrani i kyçjes "Shkruaj kodin" duhet të çojë
 * DREJT te kodi, pa e rihapur më parë provën biometrike që sapo dështoi.
 */
export async function authenticateCode(texts = {}) {
  try {
    await BiometricAuth.authenticate({
      reason: texts.reason || i18n.t("Enter the phone's code"),
      cancelTitle: texts.cancel || i18n.t("Cancel"),
      androidTitle: texts.title || i18n.t("Unlocking"),
      androidSubtitle: texts.subtitle || "",
      androidConfirmationRequired: false,
      allowDeviceCredential: true,
      iosFallbackTitle: texts.fallback || i18n.t("Use the code"),
    });
    return true;
  } catch (e) {
    if (e?.code && e.code !== "userCancel") console.warn("[bravë] kodi dështoi:", e.code, e.message);
    return false;
  }
}

/**
 * Kërkon identifikimin. Kthen true vetëm kur sistemi e konfirmon.
 *
 * DY PROVA, DHE RADHA KA RËNDËSI — këtu ishte defekti "fytyra nuk punon".
 *
 * Android-i i ndan biometrikat në "të forta" (klasa 3, zakonisht gjurma) dhe
 * "të dobëta" (klasa 2, ku bie njohja e fytyrës te shumica e telefonave). Kur
 * kërkon njëkohësisht edhe kredencialin e pajisjes — PIN-in — sistemi e ngushton
 * kërkesën te biometrika e fortë. Pra pikërisht ajo rrugë dalëse që shtova për
 * të mos mbyllur askënd jashtë, e hiqte fytyrën nga loja pa thënë asnjë fjalë.
 *
 * Prandaj: fillimisht një provë vetëm me biometri, ku lejohet edhe e dobëta —
 * këtu fytyra merr radhën e vet. Nëse ajo s'del dot (s'ka biometri, s'është
 * regjistruar, ose është bllokuar pas shumë provash), atëherë prova e dytë me
 * PIN-in. Anulimi nuk e ngjit provën e dytë: kush e mbyll dritaren e ka mbyllur
 * me qëllim, dhe butoni "Shkyç" e rinis kur të dojë.
 */
export async function authenticate(texts = {}) {
  const base = {
    reason: texts.reason || i18n.t("Confirm it is you"),
    cancelTitle: texts.cancel || i18n.t("Cancel"),
    androidTitle: texts.title || i18n.t("Unlocking"),
    androidSubtitle: texts.subtitle || "",
    androidConfirmationRequired: false,
  };

  try {
    await BiometricAuth.authenticate({
      ...base,
      allowDeviceCredential: false,
      androidBiometryStrength: AndroidBiometryStrength.weak,
      iosFallbackTitle: "",           // pa "Use passcode" këtu; vjen te prova e dytë
    });
    return true;
  } catch (e) {
    if (e?.code === "userCancel") return false;
    console.warn("[bravë] biometria nuk doli:", e?.code, e?.message);
  }

  try {
    await BiometricAuth.authenticate({
      ...base,
      // Rrugë dalëse e domosdoshme: shumë telefona s'kanë biometri të
      // regjistruar, por pothuajse të gjithë kanë PIN. Pa këtë, "e detyrueshme"
      // do të thoshte "e pamundur" për një pjesë të mirë të njerëzve.
      allowDeviceCredential: true,
      iosFallbackTitle: texts.fallback || i18n.t("Use the code"),
    });
    return true;
  } catch (e) {
    if (e?.code && e.code !== "userCancel") {
      console.warn("[bravë] identifikimi dështoi:", e.code, e.message);
    }
    return false;
  }
}
